module.exports = __webpack_public_path__ + "static/dan-b8d9904129fa0d39eb469bc06e6a2352.png";